var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivAssureDiamondIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7972 19.7536L32.1129 12.0781H28.4102L32.5974 19.7536H40.7972Z",
    fill: "#767D93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7928 12.0781H12.0901L3.41406 19.7536H11.6138L15.7928 12.0781Z",
    fill: "#767D93"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7868 19.7536L26.5995 12.0781H17.6055L13.4258 19.7536H30.7868Z",
    fill: "#767D93"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 21.3418L22.046 43.4533L30.9447 21.3418H13.25Z",
    fill: "#767D93"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21.3418L19.4948 41.324L11.541 21.3418H3Z",
    fill: "#767D93"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6603 21.3418L24.7148 41.0698L41.1938 21.3418H32.6603Z",
    fill: "#767D93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivAssureDiamondIcon);
export default __webpack_public_path__ + "static/media/ActivAssureDiamondIcon.fd359fe2e385d78c90f16499d14b33f8.svg";
export { ForwardRef as ReactComponent };